import React, { useState } from "react";

import StorySheet from "./StorySheet";
import { CLOZE_READING_CHALLENGE_SENTENCES } from "./storyLibrary";

const formatPercent = (count, total) => `${((count / total) * 100).toFixed(1)}%`;

function CategoryProgress({ category }) {
  const { articleCount, completedCount, playedCount, sentenceCount } = category;
  return (
    <div className="wikipedia-progress-category" data-testid={`wikipedia-progress-${category.category}`}>
      <div>
        <strong>{category.category}</strong>
        <small className="wikipedia-progress-muted">{articleCount} articles, {sentenceCount} sentences</small>
      </div>
      <div className="story-row-details">
        <span className="story-row-meta" title={`${playedCount} / ${articleCount} articles played`}>
          <span className="fa fa-play-circle" /> {playedCount} ({formatPercent(playedCount, articleCount)})
        </span>
        <span className="story-row-meta story-row-complete" title={`${completedCount} / ${articleCount} articles completed`}>
          <span className="fa fa-check-circle" /> {completedCount} ({formatPercent(completedCount, articleCount)})
        </span>
      </div>
    </div>
  );
}

export default function WikipediaProgress({ progress }) {
  const [isSheetVisible, setIsSheetVisible] = useState(false);
  const { categories, sentenceCount } = progress;
  const challengePercent = formatPercent(sentenceCount, CLOZE_READING_CHALLENGE_SENTENCES);

  return (
    <>
      <button className="wikipedia-progress" data-testid="wikipedia-progress" type="button" onClick={() => setIsSheetVisible(true)}>
        <span className="wikipedia-progress-header">
          <strong>Cloze-read {CLOZE_READING_CHALLENGE_SENTENCES.toLocaleString("en")} sentences</strong>
          <span className="wikipedia-progress-muted" data-testid="wikipedia-progress-count">{sentenceCount} / {CLOZE_READING_CHALLENGE_SENTENCES} ({challengePercent})</span>
          <span aria-hidden="true" className="fa fa-chevron-right story-row-chevron" />
        </span>
        <span className="wikipedia-progress-bar">
          <span style={{ width: `${Math.min((sentenceCount / CLOZE_READING_CHALLENGE_SENTENCES) * 100, 100)}%` }} />
        </span>
      </button>
      {isSheetVisible && (
        <StorySheet testId="wikipedia-progress-sheet" title="Wikipedia articles" onClose={() => setIsSheetVisible(false)}>
          {categories.map((category) => <CategoryProgress category={category} key={category.category} />)}
        </StorySheet>
      )}
    </>
  );
}
